<template>
  <div>
    <div id="bg"></div>
    <div id="wrap">
      <ul class="blind">
        <li>
          <a href="#contents">본문 바로가기(Skip Contents)</a>
        </li>
      </ul>
      <SubHeader title="Live Quiz" />
      <!-- //header -->

      <div id="container" ref="container" @click.prevent="closeme">
        <section id="contents">
          <div class="lastRank">
            <div class="rank" style="display:block;">
              <div class="bg"></div>
              <div class="trophy">
                <img src="@/assets/img/trophy.png" alt="트로피" />
              </div>
              <div class="info">
                <div class="infobg">
                  <img src="@/assets/img/trophy_inner.png" alt="1위" class="topRankimg" />
                  <img
                    v-if="1===1"
                    src="@/assets/img/trophy_inner2.png"
                    alt="2~"
                    class="otherRankimg"
                  />
                </div>
                <div class="infobox">
                  <div class="left">
                    <h6>SCORE</h6>
                    <h5>현재</h5>
                  </div>
                  <div class="right">
                    <span>{{my_rank}}</span>
                    <b>위</b>
                  </div>
                  <p>축하합니다!</p>
                  <ul>
                    <li>
                      <h3 class="c_point">{{my_point}}</h3>
                      <p>나의 정답수</p>
                    </li>
                    <li>
                      <h3>{{avg_point}}</h3>
                      <p>평균 정답수</p>
                    </li>
                    <li>
                      <h3>{{st1_point}}</h3>
                      <p>1위 정답수</p>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- info -->
            </div>
            <!-- rank -->

            <div class="rank toprank" style="display: none;">
              <div class="bg"></div>
              <div class="trophy">
                <img src="@/assets/img/trophy.png" alt="트로피" />
              </div>
              <div class="info">
                <div class="infobg">
                  <img src="@/assets/img/trophy_inner.png" alt="1위" class="topRankimg" />
                  <img src="@/assets/img/trophy_inner2.png" alt="2~" class="otherRankimg" />
                </div>
                <div class="infobox">
                  <div class="left">
                    <h6>SCORE</h6>
                    <h5>현재</h5>
                  </div>
                  <div class="right">
                    <span>{{my_rank}}</span>
                    <b>위</b>
                  </div>
                  <p>축하합니다!</p>
                  <ul>
                    <li>
                      <h3 class="c_point">{{my_point}}</h3>
                      <p>나의 정답수</p>
                    </li>
                    <li>
                      <h3>{{avg_point}}</h3>
                      <p>평균 정답수</p>
                    </li>
                    <li>
                      <h3>{{st1_point}}</h3>
                      <p>1위 정답수</p>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- info -->
            </div>
            <!-- rank -->
          </div>
          <!-- lastRank -->
        </section>
        <!-- //contents -->
      </div>
      <!-- //container -->
    </div>
    <!-- //wrap -->
  </div>
</template>

<script>
import SubHeader from "@/components/SubHeader";
import sideMixin from "@/components/SideMixin";
export default {
  mixins: [sideMixin],
  components: { SubHeader },
  computed: {
    my_rank() {
      return this.$store.state.itemMeta.my_rank;
    },
    my_point() {
      return this.$store.state.itemMeta.my_point;
    },
    avg_point() {
      return this.$store.state.itemMeta.avg_point;
    },
    st1_point() {
      return this.$store.state.itemMeta.st1_point;
    },
    headerTitle() {
      return this.$store.state.itemMeta.item_type === "quiz"
        ? "Live Quiz"
        : "Live Poll";
    },
    rankImg() {
      if (this.my_point === 0) {
        return require("@/assets/img/rank_3.png");
      } else {
        if (this.my_rank >= 10) {
          return require("@/assets/img/rank_1.png");
        } else if (this.my_rank >= 20) {
          return require("@/assets/img/rank_2.png");
        } else {
          return require("@/assets/img/rank_3.png");
        }
      }
    }
  },
  methods: {
    closeme() {
      this.$store.state.itemMeta.__page__ = "RANK";
    }
  }
};
</script>


<style lang="scss" scoped>
</style>